import React from "react";
import Controls from "./Controls";
import Log from "./Log";
import { Container } from "@mui/material";
import { AppState } from "./Types";
import Info from "./Info";
import useMediaQuery from '@mui/material/useMediaQuery';

const Side = ({
  appState,
  setAppState,
}: {
  appState: AppState;
  setAppState: React.Dispatch<React.SetStateAction<AppState>>;
}) => {

  // const smallScreen = useMediaQuery('(max-width:600px)');
  return (
    <Container
      className="side"
      sx={{ display: "flex", flexDirection: "column", placeContent: "center" }}
      // disableGutters={smallScreen}
    >
      <Info />
      <Controls appState={appState} setAppState={setAppState} />
      <Log appState={appState} setAppState={setAppState} />
    </Container>
  );
};

export default Side;
